import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiGet } from '@/shared/utils/requestBuilder';

import type { NegociacaoFlowLogs } from '../../types/flowLogs';

const BASE_URL = '/admin/negociacoes';

export const flowLogsService = {
  async getByCaso(casoId: string): Promise<NegociacaoFlowLogs> {
    const response = await apiGet(`${BASE_URL}/${casoId}/flow-logs`);
    return parseApiResponse<NegociacaoFlowLogs>(response);
  },
};
